import { render } from "./AccessDenyView.vue?vue&type=template&id=cbb113e8&scoped=true"
import script from "./AccessDenyView.vue?vue&type=script&lang=js"
export * from "./AccessDenyView.vue?vue&type=script&lang=js"

import "./AccessDenyView.vue?vue&type=style&index=0&id=cbb113e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb113e8"]])

export default __exports__